import templateUrl from "emun.customer/customer-recent-orders.htm";
import AutoQuery from "servicestack/auto-query/auto-query";
import basicController from "servicestack/basic.controller.properties";
import retailerConfig from "emun.retailer/retailer.config";

export class CustomerRecentOrdersController {
	constructor() {
		const $ctrl = this;
		basicController($ctrl);
		$ctrl.retailerId = this.customerId;
		$ctrl.customer = this.customer;
		$ctrl.retailerConfig = retailerConfig;
		$ctrl.dateTime = moment().format("MMDDYYhhmmss");
		var repGroupFilter = "";
		if ($ctrl.repGroup) {
			if ($ctrl.repGroup !== 'ALL') {
				repGroupFilter = '&RepGroup=' + $ctrl.repGroup;
			}
		}
		$ctrl.openOrders = new AutoQuery({
			url:
				"QueryCartsJoin.json?StatusNotEqualTo=Cart&retailerId=" +
				encodeURIComponent($ctrl.customerId) + repGroupFilter,
			orderBy: "-OrderedOn",
			autoLoad: true,
			pageSize: 10,
			scrollTop: false,
			disableQueryString: true,
		});
		$ctrl.openItems = new AutoQuery({
			url:
				"QueryCartItemsJoin.json?CartStatusNotEqualTo=Cart&dateRange=Last365&retailerId=" +
				encodeURIComponent($ctrl.customer.id) + repGroupFilter,
			fields: retailerConfig.recentItemsFields,
			filters: retailerConfig.recentItemsFilters,
			orderBy: "-OrderedOn",
			autoLoad: true,
			pageSize: 10,
			scrollTop: false,
			disableQueryString: true,
			hideLeftNav: true
		});
	}
	$onInit() {
		const $ctrl = this;
		$ctrl.$pageConfig.goTop();
	}
}

export default {
	bindings: {
		customerId: "@",
		repGroup: '@',
		customer: "<",
	},
	controller: CustomerRecentOrdersController,
	templateUrl($element, $attrs) {
		return $attrs.templateUrl || templateUrl;
	},
};
